import * as React from 'react'
import * as Container from "../../container/container";
import { StaticImage } from "gatsby-plugin-image";

const TextBlock5White = (key) => {
    return (
        <Container.Part background="white" key={key}>
            <Container.Row>
                <div className="col-6">
                    <figure className="lightbox karte">
                        <a className="glightbox" data-gallery="gallery2"
                           href={"/images/Ermershausen/Karte_Ermershausen-1970.png"}
                           data-glightbox="title: Kreisfreie Städte und Landkreise in Bayern vor der Gebietsreform, 1970; descPosition: bottom;">
                            <StaticImage src="../../../../static/images/Ermershausen/Karte_Ermershausen-1970.png" width={335} layout="fixed" placeholder="none"
                                 alt="Kreisfreie Städte und Landkreise in Bayern vor der Gebietsreform, 1970"/>
                        </a>
                        <figcaption>
                            Kreisfreie Städte und Landkreise in Bayern vor der Gebietsreform, 1970
                        </figcaption>
                    </figure>
                </div>
                <div className="col-6">
                    <figure className="lightbox karte">
                        <a className="glightbox" data-gallery="gallery2"
                           href={"/images/Ermershausen/Karte_Ermershausen-2021.png"}
                           data-glightbox="title: Kreisfreie Städte und Landkreise in Bayern, 2021; descPosition: bottom;">
                            <StaticImage src="../../../../static/images/Ermershausen/Karte_Ermershausen-2021.png" width={335} layout="fixed" placeholder="none"
                                 alt="Kreisfreie Städte und Landkreise in Bayern, 2021"/>
                        </a>
                        <figcaption>
                            Kreisfreie Städte und Landkreise in Bayern, 2021
                        </figcaption>
                    </figure>
                </div>
            </Container.Row>
        </Container.Part>
    )
}

export default TextBlock5White
